export default {"src":"/_next/static/media/icon_withdrawal_option_original.a7049f99.svg","height":21,"width":31,"blurWidth":0,"blurHeight":0};